import gql from 'graphql-tag'

export default gql`query filter_users($first_name: String, $last_name: String, $user_role_id: String, $email: String, $line_manager_user_id: String, $office_id: String, $limit: Int, $offset: Int) {
  filter_users(first_name: $first_name, last_name: $last_name, user_role_id: $user_role_id, email: $email, line_manager_user_id: $line_manager_user_id, office_id: $office_id, limit: $limit, offset: $offset) {
    user_id
    first_name
    last_name
    email
    user_role_id
    user_role {
      description
    }
    standard_hours_work_per_week
    active
    line_manager_user_id
    line_manager_user {
      full_name
    }
    office_id
    office {
      id
      description
      address {
        full_address
      }
    }
  }
  filter_users_total(first_name: $first_name, last_name: $last_name, user_role_id: $user_role_id, email: $email, line_manager_user_id: $line_manager_user_id, office_id: $office_id)
}
`